import {
  DOCUMNENT_DETAIL_FAILED,
  DOCUMNENT_DETAIL_FETCHING,
  DOCUMNENT_DETAIL_SUCCESS,
  server
} from '../../constants'
import backendEndpoint from '../../api/etrBackend'
import { DocumentModel } from '../../models/document'

export const setDocumentDetailFetchingToState = () => ({
  type: DOCUMNENT_DETAIL_FETCHING
})

export const setDocumentDetailSuccessToState = (payload: any) => ({
  type: DOCUMNENT_DETAIL_SUCCESS,
  payload
})

export const setDocumentDetailFailedToState = () => ({
  type: DOCUMNENT_DETAIL_FAILED
})

export const handleGetDocumentById = (id: string) => {
  return async (dispatch: any) => {
    try {
      dispatch(setDocumentDetailFetchingToState())
      const result = await backendEndpoint.get(`${server.TRANSACTION_URL}/${id}`)

      //if (result?.data?.encryptData) {
      dispatch(
        setDocumentDetailSuccessToState(
          JSON.parse(b64DecodeUnicode(result.data.encryptData).toString())
        )
      )
      // } else {
      //   dispatch(setDocumentDetailSuccessToState(result.data))
      // }
    } catch (error) {
      dispatch(setDocumentDetailFailedToState())
      throw error
    }
  }
}

export const updateDocumentById = (id: number, documentData: DocumentModel) => {
  return async (dispatch: any) => {
    try {
      dispatch(setDocumentDetailFetchingToState())
      const result = await backendEndpoint.get(`${server.TRANSACTION_URL}/${id}`)
      dispatch(setDocumentDetailSuccessToState(documentData))
    } catch (error) {
      dispatch(setDocumentDetailFailedToState())
    }
  }
}

function b64DecodeUnicode(str: string) {
  // Going backwards: from bytestream, to percent-encoding, to original string.
  return decodeURIComponent(
    atob(str)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join('')
  )
}
